import { cn } from "@/lib/utils";

export interface VideoProps
	extends React.VideoHTMLAttributes<HTMLVideoElement> {
	src: string;
	className?: string;
}

export const Video = ({ src, className, ...props }: VideoProps) => (
	<video
		{...props}
		src={src}
		controls
		playsInline
		preload="metadata"
		className={cn("h-auto max-w-full rounded-md bg-black", className)}
	/>
);
